<template>
  <ExamResult :path="'/entrain'" style="margin-top: 121px;"></ExamResult>
</template>

<script>
  import ExamResult from '@/page/modules/exam/result'
  export default {
    components: { ExamResult },
    mounted () {
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/entrain/exam/result.vue